import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        flexGrow: 1,
        position: 'relative' as const
    },
    acgContainer: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '2rem'
    },
    gridContainer: {
        marginTop: '20px',
        padding: '2rem',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    gridTitleText: {
        fontSize: '.8rem',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020',
        paddingBottom: '2rem'
    },
    detailsContainer: { paddingTop: '11px' },
    subText: {
        lineHeight: '22px',
        fontSize: '14px',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020'
    },
    fLName: { textTransform: 'capitalize' as 'capitalize' },
    acgName: { fontSize: '1.2rem' },

    actionButton: { marginRight: '1rem' },
    userLockedIcon: { marginLeft: '.5rem' },
    acgIdContainer: { marginRight: '5px' },
    acgIdBox: {
        fontSize: '1rem',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020',
        background: theme?.app?.applicationColors.detailTagBackground ||
            '#E4EFFA',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        padding: '0 11px',
        borderRadius: '5px'
    }
});